// extracted by mini-css-extract-plugin
export default {"edit":"ProductEdit_edit__j07na","information":"ProductEdit_information__xki6Z","separator":"ProductEdit_separator__QwxiP"};